import { Icon } from '@iconify/react';
import { Editor } from '@tiptap/react';
import { cn } from '@/Domain/utils/cn';

type Props = {
  editor: Editor;
  action: () => void;
  isActive: boolean;
  icon: string;
  label: string;
};

export const BubbleMenuButton = ({ action, isActive, icon, label }: Props) => (
  <button
    type="button"
    onClick={action}
    className={cn('rounded p-1 hover:bg-accent', isActive && 'bg-accent')}
    aria-label={label}
  >
    <Icon icon={icon} />
  </button>
);
